if (!customElements.get('product-social-proof')) {
  customElements.define(
    'product-social-proof',
    class ProductSocialProof extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.buyButtonBlock = this.closest('.product__info-container')?.querySelector(
            '.product-block--buy-buttons'
          );
          this.soldCountElement = this.querySelector('[data-sold-count]');
          this.breakpoint = window.matchMedia('(min-width: 1024px)');
          this.handleBreakpointChange = () => this.positionComponent();
          this.initialized = true;
          this.loadSalesCount();
        }

        if (!this.buyButtonBlock || !this.soldCountElement) return;

        this.bindBreakpointListener();
        this.positionComponent();
      }

      disconnectedCallback() {
        if (!this.breakpoint || !this.breakpointListenerBound) return;

        if (this.breakpoint.removeEventListener) {
          this.breakpoint.removeEventListener('change', this.handleBreakpointChange);
        } else {
          this.breakpoint.removeListener(this.handleBreakpointChange);
        }

        this.breakpointListenerBound = false;
      }

      bindBreakpointListener() {
        if (this.breakpointListenerBound) return;

        if (this.breakpoint.addEventListener) {
          this.breakpoint.addEventListener('change', this.handleBreakpointChange);
        } else {
          this.breakpoint.addListener(this.handleBreakpointChange);
        }

        this.breakpointListenerBound = true;
      }

      positionComponent() {
        if (!this.buyButtonBlock?.isConnected) return;

        if (this.breakpoint.matches && this.buyButtonBlock.previousElementSibling !== this) {
          this.buyButtonBlock.before(this);
        } else if (!this.breakpoint.matches && this.buyButtonBlock.nextElementSibling !== this) {
          this.buyButtonBlock.after(this);
        }
      }

      async loadSalesCount() {
        try {
          const response = await fetch(this.salesCountUrl);
          if (!response.ok) throw new Error('Unable to load product sales count');

          const data = await response.json();
          const currentPath = window.location.pathname.replace(/\/$/, '');
          const matchingProduct = data.unitSold?.find((item) =>
            String(item.url).replace(/\/$/, '').endsWith(currentPath)
          );
          const soldCount = Number(matchingProduct?.count);
          const threshold = Number(this.dataset.threshold);

          if (!Number.isFinite(soldCount) || soldCount < threshold) return;

          this.soldCountElement.textContent = `${Math.floor(soldCount / 100) * 100}+`;
          this.hidden = false;
        } catch (error) {
          this.hidden = true;
        } finally {
          this.setAttribute('aria-busy', 'false');
        }
      }

      get salesCountUrl() {
        const offset = new Date('2018-01-01').getTimezoneOffset();
        let dataCenter = 'dc1';

        if (offset <= -240) {
          dataCenter = 'dc4';
        } else if (offset <= 0) {
          dataCenter = 'dc3';
        } else if (offset <= 300) {
          dataCenter = 'dc2';
        }

        const params = new URLSearchParams({
          countType: 'session',
          duration: 'P30D',
          unitSold: '1',
          baseUrl: this.storeOrigin,
          productHandles: window.location.pathname,
        });

        return `https://${dataCenter}.convertcart.com/social/product/${this.dataset.domainId}/${this.dataset.storeId}/get?${params}`;
      }

      get storeOrigin() {
        const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href;

        try {
          return new URL(canonicalUrl || window.location.href).origin;
        } catch (error) {
          return window.location.origin;
        }
      }
    }
  );
}
